
import Vue from 'vue'
import UiCard from '@/components/UiCard.vue'
import UiButton from '@/components/UiButton.vue'
import UiIcon from '@/components/UiIcon.vue'

export default Vue.extend({
  name: "PasswordResetRequest",
  data(){
    return {
      email: '',
      emailSentTo: '',
      submitFailed: false,
      submitSuccess: false,
      loadingSubmit: false
    }
  },
  computed: {
    isCodeExpired(){
      return this.$route.query.type == "codeExpired"
    }
  },
  methods: {
    async handleSubmit(e: Event){
      e.preventDefault()
      
      try {
        this.loadingSubmit = true
        this.submitFailed = false
        await this.$store.dispatch('requestPasswordReset', this.email)
        this.emailSentTo = this.email
        this.email = ''
        // If signin succeeds show success message -> else show error
        this.submitSuccess = true
      } catch (error) {
        console.error("ERROR Submitting to forgot password", error)
        this.submitSuccess = false
        this.submitFailed = true
      } finally {
        this.loadingSubmit = false
      }
    }
  },
  components: {
    UiCard,
    UiButton,
    UiIcon,
  }
})
